export let EntityEnum = {
  FILE: 0,
  USER: 1,
  HOST: 2,
  NETWORK: 3,
  UNKNOWN: 99
};
export const eCisoKitType = {
  None: 0,
  IPhone: 1,
  IPad: 2
};

export const eEntityTypeDTO = {
  Unknown: 0,
  File: 1,
  Host: 2,
  User: 3,
  Domain: 4,
  Socket: 5,
  Kibana: 6,
  FileO: 7,
  XDR: 8,
  Login: 20,
  FileEvent: 35,
  WindowsEvent: 36,
  BashEvents: 37,
  LoadedMoudles: 38,
  ProcessSockets: 39,
  ExecutedScripts: 40,
  ApiMonitor: 41,
  Backups: 42,
  All: 100
};

export const entityTypeNamesMap = {
  [eEntityTypeDTO.Unknown]: 'Unknown',
  [eEntityTypeDTO.File]: 'File',
  [eEntityTypeDTO.Host]: 'Host',
  [eEntityTypeDTO.User]: 'User',
  [eEntityTypeDTO.Domain]: 'Network',
  [eEntityTypeDTO.Socket]: 'Socket',
  [eEntityTypeDTO.Kibana]: 'Kibana',
  [eEntityTypeDTO.FileO]: 'FileO',
  [eEntityTypeDTO.Login]: 'Login',
  [eEntityTypeDTO.FileEvent]: 'File Event',
  [eEntityTypeDTO.WindowsEvent]: 'Windows Event',
  [eEntityTypeDTO.BashEvents]: 'Shell History',
  [eEntityTypeDTO.LoadedMoudles]: 'Loaded Modules',
  [eEntityTypeDTO.ProcessSockets]: 'Process Sockets',
  [eEntityTypeDTO.ExecutedScripts]: 'Executed Scripts',
  [eEntityTypeDTO.ApiMonitor]: 'Api Monitor',
  [eEntityTypeDTO.All]: 'All'
};

export const eAlertsMenuEnum = {
  all: 0,
  files: 1,
  users: 2,
  networks: 3,
  hosts: 4
};

export const eAdvancedArtifactNodeType = {
  Unset: 0,
  User: 1,
  Host: 2,
  Process: 3,
  ExternalAddress: 4, // todo: @incomplete split into Domain or Socket
  Launcher: 5,
  DataFile: 6,
  DroppedFile: 7
};

export const eObjectRelatedEntity = {
  Unknown: 0,
  File: 1,
  Host: 2,
  User: 3,
  Domain: 4,
  Socket: 5,
  ParentFiles: 6
};

export let eEntityEnumFull = {
  UNKNOWN: 99,
  FILE: 0,
  USER: 1,
  HOST: 2,
  DOMAIN: 3,
  IP: 4,
  URL: 5
};

export let eActionId = {
  SEND_TO_SOC: 0,
  SEND_TO_ANALYSIS: 1,
  DEEP_SCAN: 2,
  VERIFY_FILE: 3,
  DELETE_FILE: 4,
  QUARANTINE_FILE: 5,
  KILL_PROCESS: 6,
  ENABLE_USER: 7,
  DISABLE_USER: 8,
  SHUT_DOWN: 10,
  RESTART: 11,
  CHANGE_IP: 12,
  DISABLE_ALL_NICS: 13,
  RUN_COMMAND: 14,
  STOP_SERVICE: 15,
  STOP_AND_DELETE_SERVICE: 16,
  BLOCK_TRAFFIC: 17,
  UNQUARANTINE_FILE: 18,
  TERMINATE: 19,
  DISABLE_SERVICE: 20,
  DISABLE_TASK: 21,
  DELETE_SERVICE: 22,
  DELETE_TASK: 23,
  RUN_FILE: 24,
  GET_STRINGS: 25,
  ROUTE_BY_DNS: 26,
  PULL_FILE: 27,
  PULL_FILE_BY_PATH: 28,
  DECOY_FILES_RE_INITIALIZE: 29,
  HOST_ISOLATE: 30,
  HOST_UNISOLATE: 31,
  SET_EPS_CUSTOM_ARGS: 32,
  CLEAR_EPS_CUSTOM_ARGS: 33,

  SCANNER_START_SCAN: 101,
  SCANNER_STOP_SCAN: 102,
  SCANNER_REMOVE_SCAN: 103,
  CUSTOM_REMEDIATION_ACTION: 104,
  PLAYBOOK_ACTION: 105,
  ADD_ARP_ENTRY_COMMENT: 106,
  UNINSTALL: 107,
  ENABLE_REINSTALL: 108,
  CANCEL_AV_SCAN: 109,
  START_FULL_AV_SCAN: 110,
  RUN_ROLLBACK: 111,

  ENABLE_AD_USER: 121,
  DISABLE_AD_USER: 122
};
export const eLinkedItemDTO = {
  Unknown: 0,
  Files: 1,
  Users: 2,
  Hosts: 3,
  Sockets: 4,
  Domains: 5,
  ProcessDlls: 6,
  StaticAnalysis: 7,
  DynamicAnalysis: 8,
  Alerts: 9,
  DeepScanAdvanced: 10,
  DeepScanNormal: 11,
  Certificates: 12,
  OSUpdates: 13,
  InstalledSoftware: 14,
  Shares: 15,
  ARP: 16,
  HOSTSfile: 17,
  IpMac: 18,
  NICs: 19,
  Logins: 20, //LoggedInUserControl
  RemoteFiles: 21, //OpenFilesFromRemoteControl
  Proxies: 22, //ProxiesControl
  DomainOccurrences: 23,
  Urls: 24, //RemoteIpsToUrlControl
  RemoteIPs: 25,
  Fileso: 26,
  DecoyOnHosts: 27,
  RiskyApplications: 28,
  OutdatedApplications: 29,
  AgentValidations: 30,
  WindowsPatches: 31,
  Audit: 32,
  DnsCache: 33,
  FileMonitor: 34,
  WindowsEvents: 35,
  DeviceControl: 36,
  BashEvents: 37,
  LoadedMoudles: 38,
  ProcessSockets: 39,
  ExecutedScripts: 40,
  ApiMonitor: 41,
  Backups: 42
};
export const eListModuleTypes = [
  { id: 0, value: 'Loaded Module' },
  { id: 1, value: 'Process' },
  { id: 2, value: 'Service' },
  { id: 3, value: 'Driver' },
  { id: 4, value: 'Service' },
  { id: 5, value: 'Loaded as Parameter' },
  { id: 6, value: 'Associated Extension' },
  { id: 7, value: 'Accessibility File' },
  { id: 10, value: 'File' },

  { id: 50, value: 'LSA Provider' },
  { id: 52, value: 'Known DLL' },
  { id: 53, value: 'Logon Script' },
  { id: 54, value: 'Explorer' },
  { id: 56, value: 'Scheduled Task' },

  { id: 57, value: 'Codec' },
  { id: 58, value: 'Boot Execution' },
  { id: 59, value: 'Network Provider' },
  { id: 60, value: 'Win logon' },

  { id: 61, value: 'IE Plugin' },
  { id: 62, value: 'Print Monitor' },
  { id: 63, value: 'Application Initializer DLL' },
  { id: 64, value: 'Sidebar Gadgets' },
  { id: 65, value: 'Hijack' },
  { id: 66, value: 'WMI' },
  { id: 67, value: 'Office Add-ins' },

  { id: 100, value: 'Linux Loaded Module' },
  { id: 101, value: 'Linux Process' },
  { id: 102, value: 'Linux Startup' },
  { id: 103, value: 'Linux Driver' },
  { id: 104, value: 'Linux Service' }
];
export let ePolicyRiskType = {
  UNKNOWN: 99,
  POSITIVE: 0,
  DISABLED: 1,
  LOW: 2,
  HIGH: 3
};

export let eObjectCircleType = {
  OBJECT: 0,
  ENTITY: 1,
  ENTITYCHILD: 2,
  POLICIES: 3
};

export let eRadar3PartsType = {
  FILESTOPRISKS: 0,
  FILESTOPAV: 1,
  FILESUNUSUALPARENTS: 2,
  NETWORKTOPRISKS: 3,
  NETWORKTOPAV: 4,
  NETWORKLOWHOSTCOUNT: 5,
  HOSTTOPRISKS: 6,
  HOSTMALICIOUSFILE: 7,
  HOSTMALICIOUSNETWORK: 8,
  USERTOPRISKS: 9,
  USERHOSTCONNECTIONS: 10,
  USERNEWESTLOCALUSERS: 11
};

export const eActionPageType = {
  UNKNOWN: 0,
  FILE: 1,
  HOST: 2,
  USER: 3,
  NETWORK: 4,
  AUTO_REMEDIATION: 5,
  PLAYBOOK_INSTANCE_ACTIONS: 6
};

export const eActionPageTabType = {
  UNKNOWN: 0,
  FILE_ACTIONS: 1,
  FILE_ANALYSIS_ACTIONS: 2,
  FILE_DEEPSCANS_ACTIONS: 3,
  USER_ACTIONS: 4,
  HOST_ACTIONS: 5,
  NETWROK_ACTIONS: 6,
  AUTO_REMEDIATION: 7,
  DECOY_FILES_ACTIONS: 8,
  PLAYBOOK_INSTANCE_ACTIONS: 9,
  SEND_TO_SOC_ACTIONS: 10,
  FILE_API_CALL_ACTIONS: 11,
  HOST_API_CALL_ACTIONS: 12,
  NETWORK_API_CALL_ACTIONS: 13,
  USER_API_CALL_ACTIONS: 14,
  AV_ACTIONS: 11
};

export const eScannerTabType = {
  MANNUAL_SCANNER: 0,
  AUTO_SCANNER: 1
};

export const eSettingsTabs = {
  SCAN_GROUPS: 'ScanGroups',
  ALLOWLIST_AND_EXCLUSIONS: 'AllowlistAndExclusions',
  CONFIGURATION: 'Configuration',
  ADVANCED: 'Advanced',
  USERS: 'Users',
  MAPS: 'Maps',
  ANALYSIS: 'Analysis',
  ALERTS: 'Alerts',
  SYSTEM_INFO: 'SystemInfo',
  EPS_CONFIGURATION: 'EpsConfiguration',
  INTEGRATIONS: 'Integrations',
  VULNERABILITY_MANAGEMENT: 'VulnerabilityManagement',
  UBA_MANAGEMENT: 'UbaManagement',
  THREAT_HUNTING: 'ThreatHunting',
  PROFILES: 'Profiles',
  USERS_GLOBAL_MANAGEMENT: 'UsersGlobalManagement',
  REMEDIATION: 'Remediation',
  WINDOWS_EVENTS_CONFIGURATION: 'WindowsEventsConfiguration',
  DECEPTION: 'Deception',
  SECURITY: 'Security',
  VIEW_REPORTS: 'ViewReports',
  SCHEDULED_REPORTS: 'ScheduledReports'
};

export const eSettingsCategory = {
  SSL_PINNING: 1
};

export const eActiveDirectoryType = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  OU: { value: 1, name: 'OU' },
  SG: { value: 2, name: 'SG' }
};

export const ePlatformType = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  WINDOWS: { value: 1, name: 'Windows' },
  LINUX: { value: 2, name: 'Linux' },
  MAC: { value: 3, name: 'Mac' },
  ANY: { value: 100, name: 'Any' }
};

export const eDistributionType = {
  RPC_TASK: { value: 0, name: 'Scheduled Tasks' },
  LiNUX_SSH: { value: 2, name: 'SSH' },
  ONE_WAY_RPC: { value: 3, name: 'RPC' },
  AUTO: { value: 4, name: 'Auto' },
  NOT_SET: { value: 5, name: 'Not Set' },
  CYNET_LAUNCHER: { value: 6, name: 'Launcher' },
  MSI: { value: 7, name: 'Manually Installed Agent' },
  UNKNOWN: { value: 99, name: 'Unknown' }
};

export const eDistributionMethod = {
  LIGHT_AGENT: { value: 0, name: 'Light Agent' },
  ALWAYS_ON: { value: 1, name: 'Always On' },
  AGENTLESS: { value: 2, name: 'Interval' }, // Obsolete
  UNKNOWN: { value: 99, name: 'UnKnown' }
};

export const eDashBoardAlertsMinSeverity = {
  UNKNOWN: { value: 0, name: 'UnKnown' },
  NON_INFO: { value: 1, name: 'All Non Informative' },
  MEDIUM_AND_ABOVE: { value: 2, name: 'Medium & Higher' },
  HIGH_CRITICAL: { value: 3, name: 'High & Critical' }
};
export const eESConnectivityStatus = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  CONNECTIVITY_TEST_SUCCESS: { value: 1, name: 'Connected successfully.' },
  ELASTICSEARCH_DISABLED: {
    value: 2,
    name: 'Elasticsearch server is disabled.'
  }
};
export const eAlertSeverity = {
  UNKNOWN: { value: 99, name: 'Unknown' },
  INFORMATIVE: { value: 1, name: 'Informative' },
  LOW: { value: 2, name: 'Low' },
  MEDIUM: { value: 3, name: 'Medium' },
  HIGH: { value: 4, name: 'High' },
  CRITICAL: { value: 5, name: 'Critical' }
};
export const eWindowsEventLogType = {
  UNKNOWN: { value: 99, name: 'UNKNOWN' },
  SECURITY: { value: 1, name: 'Security' },
  SYSTEM: { value: 2, name: 'System' },
  APPLICATION: { value: 3, name: 'Application' },
  SETUP: { value: 4, name: 'Setup' },
  PowerShell: { value: 5, name: 'Microsoft-Windows-PowerShell/Operational' },
  None: { value: 100, name: 'None' }
};
export const eDeceptionUserType = {
  UNKNOWN: { value: 99, name: 'Unknown' },
  WINDOWS: { value: 1, name: 'Windows' },
  WEB: { value: 2, name: 'Generic' }
};
export const eParserFieldsFormat = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  PARSE_BY_NAME: { value: 1, name: 'Parse By Name' },
  PARSE_BY_OFFSET: { value: 2, name: 'Parse By Offset' }
};

export const eMenuItems = {
  HOME: 0,
  ALERTS: 1,
  SEARCH: 2,
  ACTIONS: 3,
  SCANNER: 4,
  REPORTS: 5,
  SETTINGS: 6,
  MAP: 7,
  SSPM: 8,
  PLAYBOOKS: 9,
  AUDIT: 10
};

export const eReportTypes = {
  ALERT: 0,
  RISK: 1,
  VulnerabilityAssessment: 2,
  INVENTORY: 3,
  ADVANCED: 4,
  EXECUTIVE: 5
};

export const eNetworkType = {
  Socket: 0,
  Domain: 1
};

export const eAlertType = {
  UNKNOWN: { value: 99, name: 'Unknown' },
  FILE: { value: 0, name: 'File' },
  DOMAIN: { value: 1, name: 'Domain' },
  IP: { value: 2, name: 'Ip' },
  URL: { value: 3, name: 'Url' },
  USER: { value: 4, name: 'User' },
  HOST: { value: 5, name: 'Host' },
  SYSTEM: { value: 6, name: 'System' }
};

export const eAlertRemediationStatus = {
  INIT: { value: 0, name: 'Initialize' },
  NO_AUTO_REMEDIATION: { value: 1, name: 'No Auto Remediation' },
  STARTED: { value: 2, name: 'Started' },
  SUCCESS: { value: 3, name: 'Success' },
  FAILED: { value: 4, name: 'Failed' }
};

export const eEpsActionStatus = {
  NOT_SET: { value: 0, name: 'NotSet' },
  SUCCESS: { value: 1, name: 'Success' },
  FAILED: { value: 2, name: 'Failed' }
};

export const eAuthenticateType = {
  CYNET: { value: 0, name: 'Enable Local Authentication Only' },
  ACTIVE_DIRECTORY: {
    value: 1,
    name: 'Enable Active Directory Authentication Only'
  },
  ALL: { value: 2, name: 'Enable Local & Active Directory Authentication' }
};

export const eAlertStoryType = {
  Trojan: { key: 1, name: 'Trojan' },
  Ransomware: { key: 2, name: 'Ransomware' },
  MemoryInjection: { key: 3, name: 'MemoryInjection' },
  Worm: { key: 4, name: 'Worm' },
  Meterpreter: { key: 5, name: 'Meterpreter' },
  ToolBar: { key: 6, name: 'ToolBar' },
  Adware: { key: 7, name: 'Adware' },
  Spyware: { key: 8, name: 'Spyware' },
  HackingTool: { key: 9, name: 'HackingTool' },
  PortScanner: { key: 10, name: 'PortScanner' },
  KeyLogger: { key: 11, name: 'KeyLogger' },
  Sniffer: { key: 12, name: 'Sniffer' },
  PasswordDump: { key: 13, name: 'PasswordDump' },
  DNSTunneling: { key: 14, name: 'DNSTunneling' },
  TrafficToMaliciousServer: { key: 15, name: 'TrafficToMaliciousServer' },
  UnauthorizedUser1: { key: 16, name: 'UnauthorizedUser1' },
  UnauthorizedUser2: { key: 17, name: 'UnauthorizedUser2' },
  TooManyConnections: { key: 18, name: 'TooManyConnections' },
  TooMachTraffic: { key: 19, name: 'TooMachTraffic' },
  UntrustedCertificate: { key: 20, name: 'UntrustedCertificate' },
  ManInTheMiddle: { key: 21, name: 'ManInTheMiddle' },
  Decoy: { key: 22, name: 'Decoy' },
  DeviceControl: { key: 23, name: 'DeviceControl' }
};

export const eDecoyFileTypeDTO = {
  Unknown: { key: 0, name: 'Unknown' },
  Word: { key: 1, name: 'Word File' },
  Netbios: { key: 2, name: 'Netbios' },
  Rdp: { key: 3, name: 'RDP File' },
  Odbc: { key: 4, name: 'ODBC Connection' },
  Html: { key: 5, name: 'HTML File' },
  PasswordsTextFile: { key: 6, name: 'Passwords Text File' },
  UrlTextFile: { key: 7, name: 'Url Text File' },
  PasswordDump: { key: 8, name: 'Credentials' },
  PowerPoint: { key: 9, name: 'PowerPoint File' },
  Excel: { key: 10, name: 'Excel File' }
};

export const eDecoyFolderDTO = {
  Unknown: 0,
  Desktop: 1,
  Documents: 2,
  Downloads: 3
};

export const eUbaActions = {
  List: { key: 0, name: 'List' },
  Create: { key: 1, name: 'Create' },
  Edit: { key: 2, name: 'Edit' }
};
export const eWEActions = {
  List: { key: 0, name: 'List' },
  Create: { key: 1, name: 'Create' },
  Edit: { key: 2, name: 'Edit' }
};
export const eDeceptionUserActions = {
  List: { key: 0, name: 'List' },
  Create: { key: 1, name: 'Create' },
  Edit: { key: 2, name: 'Edit' }
};
export const eEventTriggerActions = {
  SMS: { value: 1, name: 'SMS' }
  // EMAIL: { value: 2, name: "Email" },
};

export const eVAReportType = {
  Unknown: 0,
  RiskyApps: 1,
  OutdatedApps: 2,
  MissingPatches: 3,
  AgentValidation: 4
};

export const eAvReplacementRemediationType = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  NO_REMEDIATION: { value: 1, name: 'Alert Only' },
  RENAME_FILE: { value: 2, name: 'Rename File' },
  DELETE_FILE: { value: 3, name: 'Delete File' }
};

export const eHostRemediationActions = {
  RestartMachine: { value: 2, label: 'Restart Machine' },
  ShutdownMachine: { value: 1, label: 'Shutdown Machine' },
  DisableAllNics: { value: 3, label: 'Disable All Nics' },
  RunCommand: { value: 7, label: 'Run Command' },
  Isolate: { value: 14, label: 'Isolate' },
  AVScan: { value: 21, label: 'Start Full AV Scan' }
};
export const eFileRemediationActions = {
  QuarantineFile: { value: 2, label: 'Quarantine File' },
  UnQuarantineFile: { value: 2, label: 'UnQuarantine File' },
  DeleteFile: { value: 1, label: 'Delete File' },
  KillProcess: { value: 5, label: 'Kill Process' }
};
export const eUserRemediationActions = {
  DisableUser: { value: 1, label: 'Disable User' }
};
export const eProxyType = {
  Unknown: { value: 0, label: 'Unknown' },
  WebApiProxy: { value: 1, label: 'WebApiProxy' },
  FileServiceProxy: { value: 2, label: 'FileServiceProxy' }
};

export const eAlertStatus = {
  Open: { value: 0, label: 'Open' },
  Pending: { value: 1, label: 'Pending' },
  Ignored: { value: 2, label: 'Ignored' },
  Closed: { value: 3, label: 'Closed' },
  OnlyCloud: { value: 4, label: 'OnlyCloud' },
  InProgress: { value: 6, label: 'InProgress' }
};
export const eOSTypeEPS = {
  Unknown: { value: 0, label: 'Unknown' },
  MSI: { value: 1, label: 'Windows MSI' },
  LINUX: { value: 3, label: 'Linux' },
  MAC: { value: 4, label: 'MAC' }
};

export const eSystemOverviewTabs = {
  InstalledOSUpdates: 1,
  MissingOSUpdates: 2,
  Arp: 3,
  InstalledSoftware: 4,
  Shares: 5,
  DeviceControl: 6
};

export const eEpsCertificateState = {
  Unknown: { value: 0, label: 'Unknown' },
  Pending: { value: 1, label: 'Pending' },
  Approved: { value: 2, label: 'Approved' },
  Rejected: { value: 3, label: 'Rejected' }
};

export const eServerHttpConnectivityStatus = {
  Unknown: { value: 0, label: 'Unknown' },
  Active: { value: 1, label: 'Active' },
  TCPActive: { value: 2, label: 'Partially Active' },
  Inactive: { value: 3, label: 'Inactive' }
};

//TODO :: move to separate file ----- global---------

export const eAvRemediationType = {
  AlertOnly: { key: 1, name: 'Alert Only' },
  RenameFile: { key: 2, name: 'Rename File' },
  DeleteFile: { key: 3, name: 'Delete File' }
};

export const eSitesBilling = {
  Unknown: 0,
  MAIN: 1,
  EDIT: 2,
  REPORTS: 3
};

export const eBillingPeriodType = {
  Unknown: { value: 0, label: 'Unknown' },
  DAY: { value: 1, label: 'Days' },
  WEEK: { value: 2, label: 'Weeks' },
  MONTH: { value: 3, label: 'Months' }
};

export const eClientSiteManagerPageTabType = {
  UNKNOWN: 0,
  PROCESSING: 1,
  CLIENT_SITES: 2,
  CREATE_SITE: 3,
  SITES_STATUS: 4,
  WEB_PROXY_MGMT: 5,
  BILLING: 6,
  EMAIL_RECIPIENTS: 7,
  MSSP_STATS: 8
};

export const eSettingsTabsGlobal = {
  SCAN_GROUPS: 'ScanGroups',
  USERS: 'Users',
  SIEM: 'Siem',
  INTEGRATIONS: 'Integrations',
  CLIENT_SITE_MANAGER: 'ClientSiteManager',
  SETTINGS: 'Settings',
  ALLOWLIST_AND_EXCLUSIONS: 'AllowlistAndExclusions'
};

export const eAlertSortOptions = {
  UNKNOWN: { value: 0, name: 'Unknown' },
  LAST_SEEN: { value: 1, name: 'Last Seen' },
  FIRST_SEEN: { value: 2, name: 'First Seen' },
  ALERT_ID: { value: 3, name: 'Alert ID' }
};

export const eSyslogConnectionType = {
  UDP: { value: 0, name: 'UDP' },
  TCP: { value: 1, name: 'TCP' },
  TCP_TRACE: { value: 2, name: 'TCP TraceLog' }
};

export const msspFilterType = {
  All: '0',
  DirectCustomers: '1',
  MSSP: '2'
};

export const eRetentionType = {
  NotPaying: { value: 1, name: 'CLM Trial' },
  Paying30Days: { value: 2, name: 'CLM 30-Day Retention' },
  Paying90Days: { value: 3, name: 'CLM 90-Day Retention' },
  ColdStorage: { value: 4, name: 'CLM Long Term Retention' }
};

export const eLicenseType = {
  Unknown: 0,
  CLM: 1
};
export const eLicenseRequestStatus = {
  Unknown: 0,
  Pending: 1,
  Success: 2,
  Failed: 3
};

export const eLogoutReason = {
  UpdateUserInteractionSuccessLogout: 1,
  UpdateUserInteractionResponseStatus401: 2,
  ValidateUserActivityIntervalNoResponse: 3,
  EditSelfUserDialogIsAllSitesOrAssociatedSitesChanged: 4,
  EditSelfUserDialogNewRoleHasNoEditUsersPermission: 5,
  RefreshTokenCheckerResponseStatus401: 6,
  UserActivityTrackerOnIdleTimeout: 7,
  UserActivityTrackerOnActivityTokenExpirationNotFound: 8,
  LogoutMenuButton: 9
};
